import { UserSessionModelAsAdmin } from 'front-end/src/graphql/private/PrivateSchemaTypes'

// this needs a separate file, because when it was inlined in LogInAsUser it broke IE11
export const getLoginLinkForSession = (session: UserSessionModelAsAdmin) => {
  return `${session?.organisation.subdomain?.fullUrl}authSuccessCallback/${session?.signedSid}`
}
